var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Loader'),_c('router-view'),(_vm.isAuthenticated)?_c('notification-prompt'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }